import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'DurationFromDatetime' })
export class DurationFromDatetimePipe implements PipeTransform {
  private dayIndicator = $localize`:@@duration-day:Tag(e)`;
  private hourIndicator = $localize`:@@duration-hour:Std.`;
  private minuteIndicator = $localize`:@@duration-minute:Min.`;
  private secondIndicator = $localize`:@@duration-sec:Sek.`;

  constructor(@Inject(LOCALE_ID) private locale: string) {}

  transform(starts_at: string | undefined, ends_at: string | undefined, hideSeconds: boolean | undefined = true) {
    if (!starts_at || !ends_at) {
      return '0';
    }

    const startsAt = Date.parse(starts_at);
    const endsAt = Date.parse(ends_at);
    let delta = Math.abs(startsAt - endsAt) / 1000;

    const days = Math.floor(delta / 86400);
    delta -= days * 86400;

    const hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;

    const minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;

    const seconds = delta % 60;

    let result = '';
    let previousValuePresent = false;

    if (days > 0) {
      result += days + ' ' + this.dayIndicator;
      previousValuePresent = true;
    }

    if (hours > 0) {
      result = result + (previousValuePresent ? ', ' : '') + hours + ' ' + this.hourIndicator;
      previousValuePresent = true;
    }

    if (minutes > 0) {
      result = result + (previousValuePresent ? ', ' : '') + minutes + ' ' + this.minuteIndicator;
      previousValuePresent = true;
    }

    if (seconds > 0 && !hideSeconds) {
      result = result + (previousValuePresent ? ', ' : '') + seconds + ' ' + this.secondIndicator;
    }

    if (result.length === 0) {
      result = '0 ' + this.secondIndicator;
    }

    return result;
  }
}
